var map = {
	"./Sample_Formatting_After.png": 527,
	"./Sample_Formatting_Before.png": 528,
	"./Sample_Outline.png": 529,
	"./Sample_Proofreading_and_formattingAfter.png": 530,
	"./Sample_Proofreading_and_formatting_Before.png": 531,
	"./Sample_Sources.png": 532,
	"./before_after_1.png": 533,
	"./before_after_cut.png": 534,
	"./icons.svg": 92,
	"./micro-1.svg": 535,
	"./micro-2.svg": 536,
	"./micro-3.svg": 537,
	"./preview1.png": 538,
	"./preview2.png": 539,
	"./preview3.png": 540,
	"./preview4.png": 541,
	"./preview5.png": 542,
	"./preview6.png": 543,
	"./services-img1.svg": 544,
	"./services-img2.svg": 545,
	"./services-img3.svg": 546,
	"./services-img4.svg": 547,
	"./source/pdf-icon.svg": 548,
	"./source/zoom-icon.svg": 549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 526;